import { createAsyncThunk } from '@reduxjs/toolkit';
import familyFestApi from '@infrastructure/family-fest-api';
import { getErrorPayload } from '@application/helpers/api-helper';
export const getFamilyFestDashboardAnalytics = createAsyncThunk('familyFestAnalytics/getDashboardAnalytics', async (id, { rejectWithValue }) => {
    try {
        const response = await familyFestApi.getFamilyFestAnalytics(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFamilyFestResponsesAnalytics = createAsyncThunk('familyFestAnalytics/getResponsesAnalytics', async (id, { rejectWithValue }) => {
    try {
        const response = await familyFestApi.getFamilyFestTotalResponses(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
